import * as React from 'react';
import { AppContextProps, withApp } from '../_context/App';
import { RouteComponentProps, withRouter } from 'react-router';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import DocumentMeta from 'react-document-meta';
import List from './List';
import Project from './Project';
import TextPage from './TextPage';
import DownloadPage from './DownloadPage';
import ListMobile from './ListMobile';
import Spinner from './Spinner/Spinner';

export type PageProps = React.HTMLAttributes<HTMLElement> & {
    isMobile: boolean;
};

const styles = {
    container: {
        // [responsive.Mobile]: {
        //   margin: `0 ${spacing.Gutter.Mobile/2}px`
        // }
    }
}
type Props = PageProps &
    StyledComponentProps<keyof typeof styles> &
    RouteComponentProps<any> & {
        appContext: AppContextProps;
    };
type State = {
    page?: IPageDto;
}

class Page extends React.Component<Props, State> {

    private scrollContainer = document.scrollingElement ? document.scrollingElement : document.documentElement;

    constructor(props: Props) {
        super(props);

        this.state = {
            page: props.appContext.app && props.appContext.app.Page
        }
    }

    componentDidMount() {
        if (!this.state.page) {
            this._fetch();
        }

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {

        if (prevProps.location.pathname !== this.props.location.pathname) {
            this._fetch();
        }

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    public render() {
        const { classes, isMobile, ...rest } = this.props;
        const { page } = this.state;

        return (
            <div className={classNames(classes!.container, rest.className)}>
                {page ? <React.Fragment>
                    <DocumentMeta
                        title={page.PageTitle || ''}
                        description={page.Description || ''}
                    />
                    {page.type === "TextPage" &&
                        <TextPage
                            {...{ page: page as TextPageDto }}
                        />}
                    {page.type === "DownloadPage" &&
                        <DownloadPage
                            {...{ page: page as DownlaodPageDto }}
                        />}
                    {page.type === "List" && !isMobile &&
                        <List
                            {...{ page: page as ListDto }}
                        />
                    }
                    {page.type === "List" && isMobile &&
                        <ListMobile
                            {...{ page: page as ListDto }}
                        />
                    }
                    {page.type === "Project" &&
                        <Project
                            {...{ project: page as ProjectDto, isMobile }}
                        />
                    }
                </React.Fragment> : <Spinner />}
            </div>
        );
    }

    private _fetch() {
        this.setState(() => {
            this.props.appContext.get(this.props.location.pathname).then(result => {
                this.setState(() => ({ page: result }));
            });
            return { page: undefined };
        });

    }
}

export default withStyles(styles)(withRouter(withApp(Page)));


// WEBPACK FOOTER //
// ./src/Components/Page.tsx